<template>
  <div :class="classes">
    <pt-page-title v-if="!hideTitle" :title="title" :isSearch="true" isQueryRouter @search="search" @emptySearch="emptySearch" :searchKey="searchKey">
      <template slot="before-left" v-if="!hideBtn">
        <el-button type="primary" @click="createdLabProduct">新建检测项目</el-button>
      </template>
    </pt-page-title>
    <!-- <pt-page-factor-filter :labels="filterLabels" v-model="filterCondition"  isQueryRouter @Filter="Filter" ref="filter">
        <template>
            <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
          </template>
      </pt-page-factor-filter> -->
    <div>
      <slot name="otherBtn" />
    </div>
    <pt-lab-product-table :params-data="paramsData" ref="tableWithData" :isFromRouter="isFromRouter" :selectType="selectType" v-on="$listeners" @selection-change="handleSelectionChange" :selectedKeys="selectedKeys" :isDialog="isDialog" :productList="productList" :noQuery="noQuery">
    </pt-lab-product-table>
  </div>
</template>

<script>
import ptLabProductTable from './pt-lab-product-table/withData'
import { filterLabels } from './lab-product-option.js'
import {
  emptyObject
} from '@/utils/lifebankUtils'
// 组件class前缀
const prefixCls = 'pt-lab-product'

export default {
  name: 'pt-lab-product',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLabProductTable
  },
  props: {
    isDialog: Boolean,
    hideTitle: {
      type: Boolean,
      default: false
    },
    methodList: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: '检测项目'
    },
    selectType: {
      type: String,
      default: ''
    },
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    productList: Array,
    noQuery: Boolean // 无需请求接口
  },
  data () {
    return {
      filterLabels: filterLabels,
      filterCondition: {},
      paramsData: {},
      isFromRouter: false,
      searchKey: ''
    }
  },
  watch: {
    methodList: {
      handler: function (val) {
        this.filterLabels.forEach(item => {
          if (item.value === 'methodId') {
            item.options = val
          }
        })
      },
      immediate: true,
      deep: true
    }
    // filterCondition: {
    //   handler: function (val) {
    //     this.Filter()
    //   },
    //   immediate: true,
    //   deep: true
    // }
  },
  methods: {
    createdLabProduct () {
      this.$router.push('/lab-product/lab-product-form/false/0')
    },
    search (val) {
      this.searchKey = val
      emptyObject(this.filterCondition)
      emptyObject(this.paramsData)
      this.$set(this.filterCondition, 'searchKey', val)
      this.$set(this.paramsData, 'searchKey', val)
    },
    emptySearch (val) {
      this.searchKey = null
      this.$delete(this.paramsData, 'searchKey')
    },
    cleanParams () {
      emptyObject(this.filterCondition)
      emptyObject(this.paramsData)
    },
    // Filter (isFromRouter) {
    //   this.isFromRouter = isFromRouter
    //   for (let key in this.filterCondition) {
    //     if (!this.filterCondition[key]) {
    //       this.$delete(this.filterCondition, key)
    //     }
    //   }
    //   if (!isFromRouter) {
    //     this.$nextTick(_ => {
    //       this.$refs.filter.getAddRouter(this.filterCondition)
    //     })
    //   }
    //   this.paramsData = { ...this.filterCondition }
    // },
    goEdit (row) {
      this.$router.push(`/lab-product/lab-product-form/true/${row.id}`)
    },
    goDelete (row) {
      this.$confirm(`确定要删除实验室产品：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // console.log('this.$refs.tableWithData.load()', this.$refs)
        // console.log('this.$refs.tableWithData.load()', this.$refs.tableWithData)
        // this.$refs.tableWithData.load()
        this.$store.dispatch('deleteLabProduct', row.id).then(data => {
          console.log('this.$refs.tableWithData.load()', this.$refs)
          console.log('this.$refs.tableWithData.load()', this.$refs.tableWithData)
          this.$refs.tableWithData.load()
          this.$message.success('删除成功！')
        }).catch(err => {
          this.$message.error(err)
        })
      })
    },
    handleSelectionChange (val) {
      this.$emit('selection-change', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.opreation-button{
    :global
    .iconfont{
        margin-right: 10px;
    }
}
</style>
